import React, { useState, useEffect } from 'react';

/** Form validation */
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import usePostAxiosData from 'hooks/usePostAxiosData';
import toast from 'react-hot-toast';
import InputField from 'components/fields/InputField';
import Error from 'components/message/Error';
import { config } from 'variables/config';
import useDataFetching from 'hooks/useDataFetching';
import MuiSelect from 'components/MuiSelect';
import { AppBar, Dialog, DialogContent, Toolbar, Typography } from '@mui/material';
import MButton from 'components/Mbutton';
import { CloseModalButton } from 'components/Utils';
import { useTranslation } from 'react-i18next'; // Importer useTranslation

const AddZone = (props) => {
  const { isOpen, onClose } = props;
  const { t } = useTranslation('add_zone');

  /** Form validation config */
  const schema = yup.object().shape({
    number: yup.string().required(t('number_required')), // Traduit
    description: yup.string(),
  });

  const [departement, setDepartement] = useState(null);
  const [regionId, setRegionId] = useState(null);

  const [loadingR, errorR, regions, fetchDataR] = useDataFetching(`${config.app.api_url}/regions`);

  const [loadingD, errorD, departments, fetchDataD] = useDataFetching(
    regionId && regionId !== '*' ? `${config.app.api_url}/regions/${regionId}/departments` : null
  );

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  console.log('🚀 ~ AddMission ~ errors:', errors);
  const onSubmitHandler = (data) => {
    handleSave(data);
  };

  /** post create user */
  const [loading, postAxiosData, errorMassage, successMessage, result] = usePostAxiosData(
    `zones`,
    'POST'
  );

  const handleSave = async (dataYub) => {
    const data = {
      ...dataYub,
      regionId,
      departmentId: departement,
    };
    // console.log("🚀 ~ handleSave ~ data:", data)
    await postAxiosData(data);
  };

  /** gestion des erreurs et succès */
  useEffect(() => {
    if (successMessage?.status === 200 || successMessage?.status === 201) {
      reset();
      toast.success(
        `${
          successMessage?.message != null ? successMessage?.message : t('success_message') // Traduit
        }`,
        {
          duration: 4000,
          className: 'bg-success text-white',
        }
      );
      props?.endFetch();
      onClose();
    }
  }, [successMessage, reset, props, onClose, t]); // Ajouter 't' aux dépendances

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar className="bg-gray-50">
            <Typography
              sx={{ ml: 2, flex: 1 }}
              color={'green'}
              fontWeight={'bold'}
              variant="h6"
              component="div"
            >
              {t('create_zone_title')} {/* Traduit */}
            </Typography>
            <CloseModalButton iconColor={'red'} handleClose={onClose} />
          </Toolbar>
        </AppBar>

        <DialogContent dividers>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <div className="my-4 grid gap-2 md:grid-cols-1">
              {errorMassage?.message && (
                <Error message={errorMassage?.message !== '' && errorMassage?.message} />
              )}

              <MuiSelect
                label={t('region_label')}
                value={regionId}
                options={regions.data}
                format={{ value: 'id', label: 'name' }}
                onChange={(event) => {
                  setRegionId(event.target.value);
                }}
                emptyLabel={t('none_option')}
              />
              <MuiSelect
                label={t('department_label')}
                value={departement}
                options={departments.data}
                format={{ value: 'id', label: 'name' }}
                onChange={(event) => {
                  setDepartement(event.target.value);
                }}
                emptyLabel={t('none_option')}
              />
              <InputField
                register={register}
                variant="auth"
                extra="mb-3"
                label={t('number_label')}
                required={true}
                placeholder={t('number_placeholder')}
                id="number"
                name="number"
                type="number"
                error={errors.number?.message !== '' ? errors.number?.message : ''}
              />

              <InputField
                register={register}
                variant="auth"
                extra="mb-3"
                label={t('description_label')}
                required={true}
                placeholder={t('description_placeholder')}
                id="description"
                name="description"
                type="text"
                error={errors.description?.message !== '' ? errors.description?.message : ''}
              />
            </div>
            <div className="flex justify-between p-4">
              <div>
                <MButton
                  variant={'danger'}
                  onClick={(e) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    onClose();
                  }}
                >
                  {t('close_button')} {/* Traduit */}
                </MButton>
              </div>
              <div>
                <MButton variant={'primary'} type="submit" colorScheme="green">
                  {t('create_button')} {/* Traduit */}
                </MButton>
              </div>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddZone;
